import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-tft-solo-normal-games',
  templateUrl: './tft-normal-games.component.html'
})
export class TftNormalGamesComponent {
  service = 'normalgames';
  availableServices = services['tft'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'tft',
    service: 'normalgames',
    type: 'solo',
    title: {
      en: 'Normal Wins',
    },
    subtitle: {
      "en": "Guaranteed Unranked Wins, ideal for Season Pass and Missions",
      "fr": "Victoires non classées garanties, idéales pour le Passe de Saison et les Missions",
      "de": "Garantierte nicht rangierte Siege, ideal für Season Pass und Missionen",
      "pt": "Vitórias unranked garantidas, ideais para o Season Pass e Missões",
      "es": "Victoires non classées garanties, idéal pour le Season Pass et les missions",
    },
    start: 9,
    desired: 10,
    serviceName: {
      en: 'Wins',
      fr: 'Siege'
    },
    min: 1,
    max: 10
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Normal Win Boosting Service?",
        answer: "Normal Wins are an unranked service that guarantees a predetermined amount of unranked victories."
      },
      {
        question: "In Which Game Mode Are Normal Wins Played?",
        answer: "Normal Wins, being an unranked service, are always played in Normal Queue."
      },
      {
        question: "Do Losses Count Towards Order Progression?",
        answer: "Only wins are counted, therefore when you purchase 10 Normal Wins, you are guaranteed to have played at least 10 games."
      },
      {
        question: "Can I Use This Service To Complete Missions Or Pass Levels?",
        answer: "Yes, you can. As long as the service is active we will try to complete as many missions and levels as possible."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, unless you want to queue in the same ranking mode as the bought service. Other than that, schedule it in the order chat with your booster."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un service de Boosting Normal?",
        answer: "Les victoires normales sont un service non classé qui garantit un nombre prédéterminé de victoires non classées."
      },
      {
        question: "Dans quel mode de jeu les victoires normales sont-elles jouées?",
        answer: "Les victoires normales, étant un service non classé, sont toujours jouées dans la queue normale."
      },
      {
        question: "Les défaites sont-elles prises en compte dans la progression des commandes?",
        answer: "Seuls les victoires sont prises en compte. Par conséquent, lorsque vous achetez 10 victoires normales, vous avez la garantie d\'avoir joué au moins 10 parties."
      },
      {
        question: "Puis-je utiliser ce service pour accomplir des missions ou passer des niveaux?",
        answer: "Oui, c\'est possible. Tant que le service est actif, nous essaierons de compléter autant de missions et de niveaux que possible."
      },
      {
        question: "Puis-je jouer pendant que la commande est active ?",
        answer: "Oui, sauf si vous voulez jouer dans le même mode classé que le service acheté. Dans le cas contraire, planifiez-le dans le chat de commande avec votre booster."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      }
    ],
    de: [
      {
        question: "Was ist ein Normal Win Boosting Service?",
        answer: "Normal Wins sind ein rangloser Service, der eine bestimmte Anzahl von ranglosen Siegen garantiert."
      },
      {
        question: "In welchem Spielmodus werden Normal Wins gespielt?",
        answer: "Normal Wins werden, da es sich um einen Dienst ohne Rang handelt, immer in der normalen Warteschlange gespielt."
      },
      {
        question: "Zählen Verluste für den Bestellungsfortschritt?",
        answer: "Es werden nur Gewinne gezählt. Wenn du also 10 normale Gewinne kaufst, hast du garantiert mindestens 10 Spiele gespielt."
      },
      {
        question: "Kann ich diesen Service nutzen, um Missionen zu erfüllen oder Levels zu bestehen?",
        answer: "Ja, das kannst du. Solange der Dienst aktiv ist, werden wir versuchen, so viele Missionen und Level wie möglich abzuschließen."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du möchtest im gleichen Ranking-Modus wie der gekaufte Dienst spielen. Ansonsten planst du das mit deinem Booster im Auftragschat."
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O Que É Um Serviço De Normal Wins Boosting?",
        answer: "As Normal Wins são um serviço exclusivo para jogos não ranked que garante uma quantidade predeterminada de vitórias."
      },
      {
        question: "Em Que Modo De Jogo São Jogadas As Normal Wins?",
        answer: "As Normal Wins, sendo um serviço não ranked, são sempre jogadas em Normal Queue ou Eventos Especiais."
      },
      {
        question: "As derrotas contam para a progressão do pedido?",
        answer: "Apenas as vitórias são contadas. Portanto, ao comprar 10 Vitórias Normais, você garante ter jogado pelo menos 10 partidas."
      },
      {
        question: "Posso Usar Este Serviço Para Completar Missões Ou Níveis De Event Pass?",
        answer: "Sim, podes. Enquanto o serviço estiver activo, tentaremos completar o maior número de missões e níveis."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, a menos que queira entrar na mesma fila de ranqueamento do serviço comprado. Caso contrário, planeje isso no chat do pedido com seu booster."
      },
      {
        question: "Posso Escolher O Mesmo Booster Para Uma Compra Futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un servicio de boosting de Normal Wins?",
        answer: "Las Normal Wins son un servicio sin clasificación que garantiza una cantidad predeterminada de victorias sin clasificación."
      },
      {
        question: "¿En qué modo de juego se juegan las victorias normales?",
        answer: "Las victorias normales, al ser un servicio no clasificado, siempre se juegan en la cola normal."
      },
      {
        question: "¿Cuentan las pérdidas para la progresión de la orden?",
        answer: "Sólo se cuentan las victorias, por lo tanto, al comprar 10 Ganancias Normales, se garantiza que ha jugado al menos 10 partidas."
      },
      {
        question: "¿Puedo utilizar este servicio para completar misiones o pasar de nivel?",
        answer: "Sí que se puede. Mientras el servicio esté activo intentaremos completar tantas misiones y niveles como sea posible."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, a menos que quieras hacer cola en el mismo modo de clasificación que el servicio comprado. Aparte de eso, prográmalo en el chat de órdenes con tu booster."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "TFT Boost - Normal Wins Boosting for Teamfight Tactics",
      fr: "Boost TFT - Boosting de Victoires Normale sur Teamfight Tactics",
      de: "TFT Boost - Normal Wins Boosting für Teamfight Tactics",
      pt: "Boost TFT - Vitórias Normais para Teamfight Tactics",
      es: "TFT Boost - Boosting de victorias normales para Teamfight Tactics",
    },
    metaDescription: {
      en: "Looking to improve your normal game MMR in TFT? Our affordable, fast, and secure service will help you queue against better players and test your skill.",
      fr: "Vous cherchez à améliorer votre MMR en partie normale sur TFT ? Notre service abordable, rapide et sécurisé vous permettra d\'affronter de meilleurs joueurs et de tester vos capacités.",
      de: "Willst du deine MMR im normalen Spiel auf TFT verbessern? Tritt gegen bessere Spieler an und teste deine Fähigkeiten mit unserem preiswerten, schnellen und sicheren Service.",
      pt: "Procurando melhorar seu MMR em partidas normais no TFT? Nosso serviço acessível, rápido e seguro ajudará você a entrar na fila contra jogadores melhores e testar suas habilidades.",
      es: "¿Buscas mejorar tu MMR de juego normal en TFT? Nuestro servicio asequible, rápido y seguro te ayudará a hacer cola contra mejores jugadores y a poner a prueba tu habilidad.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }
    });

    title.setTitle(this.page.title[this.lang] || this.page.title['en']);

    meta.updateTag(
      {
        name: 'description',
        content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
      },
    );
  }
}